module.exports = __webpack_public_path__ + "media/site_templates/www.cheapgardenservices.com.au/images/splash-fd844f2c8722906762f961047d9012db.jpg";